// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"878226c5","769":"b23fb3ef"}[chunkId] + ".chunk.js";
};